
import { useEffect, useState } from "react";
import { HeroHeader, HeroQuestions, HeroAwakening, HeroPathForward } from "@/components/hero";

export default function Hero() {
  const [visible, setVisible] = useState(false);

  // Pain points data
  const painPoints = [
    {
      title: 'Why doesn\'t this feel like enough?',
      description: "Your net worth grows while your sense of self-worth quietly diminishes."
    },
    {
      title: 'What will actually remain when I\'m gone?',
      description: "You've built impressive structures but question their lasting significance."
    },
    {
      title: 'Why do I feel so alone despite all these connections?',
      description: "Your influence extends globally, yet authentic relationships feel increasingly rare."
    },
    {
      title: 'Where did all the time go?',
      description: "Your calendar is perfectly optimized, yet life itself seems to be slipping away."
    }
  ];

  // Contrast points data
  const contrastPoints = [
    {
      title: "A foundation for genuine legacy",
      description: 'How do I create something that transcends quarterly results?'
    },
    {
      title: "Connection with genuine purpose",
      description: 'What if my influence served something greater than itself?'
    },
    {
      title: "Wealth that nourishes rather than consumes",
      description: 'Can success actually feed my soul instead of depleting it?'
    },
    {
      title: "Time that expands rather than constricts",
      description: 'Is there a rhythm to life that creates both productivity and peace?'
    }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section 
      className="min-h-screen flex flex-col items-center justify-center pt-24 sm:pt-26 md:pt-32 pb-10 sm:pb-12 md:pb-20"
      aria-labelledby="hero-heading"
    >
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center space-y-10 md:space-y-20">
          <HeroHeader visible={visible} />
          <HeroQuestions painPoints={painPoints} visible={visible} />
          <HeroAwakening visible={visible} />
          <HeroPathForward contrastPoints={contrastPoints} />
        </div>
      </div>
    </section>
  );
}
